import { useCallback, useState } from "react";

export function useWorkflowDialogState(initialValue = false) {
  const [isOpen, setIsOpen] = useState(initialValue);

  const setOpen = useCallback((value) => {
    setIsOpen(value);
  }, []);

  const openDialog = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    setOpen,
    openDialog,
    closeDialog,
  };
}
